export const Fadein = () => {
	const viewIn = () => {
		const elements = Array.prototype.slice.call(document.body.querySelectorAll(".fade"));
		const options = {
			rootMargin: "0px",
			threshold: [0]
		};
		const fader = (el) => {
			el.forEach(t => {
				if (t.intersectionRatio > 0) {
					// console.log(t)
					const target = t.target;
					target.classList.add("view_in")
					isObserver.unobserve(target);
				}
			});
		};
		const isObserver = new IntersectionObserver(fader, options)
		elements.forEach(el => {
			isObserver.observe(el);
		});
	}
	viewIn();
}
